export const PARTNER_APPLICATION_TOTAL_STEPS = 4;

export const STEP_INDEX_BUSINESS = 0;
export const STEP_INDEX_STORES = 1;
export const STEP_INDEX_AGENTS = 2;
export const STEP_INDEX_REVIEW = 3;
